import React, { useState } from "react";
import { Modal, Box } from "@mui/material";
import { RootState } from "../../../Store/store";
import { useDispatch, useSelector } from "react-redux";
import { setQnaReplyStringRedux } from "../../../Store/slices/qnaSlice";

interface ReplyQnaModalProps {
    visible: boolean;
    onClose: () => void;
    onClickSend: () => void;
    selectedQnaTitle?: string;
}

const QnaReplyModal = ({
    visible,
    onClose,
    onClickSend,
    selectedQnaTitle,
}: ReplyQnaModalProps) => {
    const dispatch = useDispatch();
    const { qnaReplyString } = useSelector((state: RootState) => state.qna.value);
    return (
        <div className="flex items-center justify-center h-screen bg-gray-100">
            <Modal
                open={visible}
                onClose={onClose}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box
                    className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 bg-white rounded-lg shadow-lg p-6"
                >
                    <h2 id="modal-title" className="text-lg font-semibold text-gray-700">
                        Reply for: <br /><strong className="text-black">{selectedQnaTitle}</strong>
                    </h2>
                    <p id="modal-description" className="mt-2 text-gray-600">
                        Please write your reply below.
                    </p>

                    <textarea
                        value={qnaReplyString}
                        onChange={(e) => dispatch(setQnaReplyStringRedux(e.target.value))}
                        className="mt-4 w-full h-32 p-2 border border-gray-300 rounded"
                        placeholder="Reply"
                    >

                    </textarea>

                    <button
                        disabled={qnaReplyString.length === 0}
                        className={`mt-4 px-4 py-2 ${qnaReplyString.length === 0 ? 'bg-gray-400' : 'bg-yellow-500'}  text-white rounded  ${qnaReplyString.length === 0 ? '' : 'hover:bg-yellow-600'}`}
                        onClick={onClickSend}
                    >
                        Reply
                    </button>
                    <button
                        className="mt-4 px-4 py-2 bg-gray-300 text-gray-600 rounded hover:bg-gray-400 ml-4"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                </Box>
            </Modal>
        </div>
    );
};

export default QnaReplyModal;
